import React from "react";

function SortToggle({ sortMode, onToggle, itemCount, itemLabel }) {
  const label = sortMode === "pop" ? "Popular" : "A\u2013Z";

  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "9px 12px 4px",
    }}>
      <span style={{
        fontSize: "12px",
        color: "var(--tg-theme-hint-color, #999)",
      }}>
        {itemCount} {itemCount === 1 ? itemLabel : `${itemLabel}s`}
      </span>
      <button
        onClick={onToggle}
        style={{
          padding: "6px 11px",
          borderRadius: "9px",
          border: "1px solid var(--tg-theme-hint-color, #ccc)",
          background: "var(--tg-theme-secondary-bg-color, #f5f5f5)",
          fontSize: "12px",
          fontWeight: "600",
          color: "var(--tg-theme-text-color, #333)",
          cursor: "pointer",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        {"\u21C5"} {label}
      </button>
    </div>
  );
}

export default SortToggle;
